import ThreeColumnImageRepository from "../ThreeColumnImageRepository"

export default class WhyPodiemThreeColumnImage extends ThreeColumnImageRepository {
    static schemaId = "why_us_threeColumnImage"

    constructor() {
        super(WhyPodiemThreeColumnImage.schemaId)
    }
}
